var _expanded = false, curHeight, autoHeight, originalHeight;

var paginaGaleria = 1;

window.onload = function() {
	equalHeights('alturaIgualLinha');
	
	
	function resizeGalerias() 
	{
		//alert($('#geralGalerias').height());
		//alert($('#containerGalerias').height());
		
		$('#containerGalerias').height($('#geralGalerias').height());
	}

	resizeGalerias();
	
	$(window).resize(function () {			
		resizeGalerias();
	});
	
	
};

jQuery(document).ready(function ($) {

	/******* BXSLIDER RESPONSIVE *******/
	
	var screensize = $(window).width();
	var sliderDG;
	var slider_number = 3;
	var moveSlides_number = 3;
	var slide_width = 0;

	sliderDG = $('.bxslider').bxSlider();
	
	jQuery(window).on("orientationchange load resize", function () {
		bxslider();
	});

	function bxslider() {
		
		var screensize = $(window).width();
		
		if (screensize < 760) {
			slider_number = 1;
			moveSlides_number = 1;
			slide_width = 0;
		}
		else {		
			if (screensize >= 760 && screensize <= 1090)
			{
				slider_number = 2;	
				slide_width = 431;	
			}	
			else
			{
				slider_number = 3;
				slide_width = 398;
			}

			moveSlides_number = slider_number;
		}
					
		if (sliderDG.length > 0) {
			sliderDG.reloadSlider({

				nextSelector: '#slider-next',
				prevSelector: '#slider-prev',
				nextText: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
				prevText: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
				infiniteLoop: false,
				minSlides: slider_number,
				maxSlides: slider_number,
				moveSlides: slider_number,
				slideWidth: slide_width,
				slideMargin: (screensize < 760) ? 0 : 9,
				hideControlOnEnd: true//,
				//pager: ($(".related-slider li").length > 4) ? true : false

			});
		}
		jQuery('#containerProximasProvas').css('visibility','visible');
	}

	/***** FIM BXSLIDER RESPONSIVE *****/
	
	
	/******* GALERIA *******/
	
	
	
	
	$(".show-gallery, .show-gallery-icon").click(function(e){
    		
		e.preventDefault();
		var container = $('#loadmorefollowers');
		var newhtml = '';
		//alert(paginaGaleria);
				
		//$('#followbtn').fadeOut(300);

		//alert(idGaleria);
		//alert(ajaxurl);
		
		
		$(".loading-container").css("display","block");
		
		$.ajax({
			//url: '/fpj.pt/ajax-galerias.php',
			//url: ajaxurl + 'ajax-galerias.php',
			url:frontend_ajax_object.ajax_url,
			type: 'post',
			//data: {'page': $(this).attr('href')},
			dataType: "json",
			data: {'action': 'devolve_imagens', 'page' : '#pg1','idGaleria' : idGaleria,'paginaGaleria' : paginaGaleria},			
			cache: false,
			
			success: function(json) {
				
				//console.log(json);
				paginaGaleria++;
				
				
				//$.each(json.listaimagens, function(property, value) {
					//console.log(property + "=" + value);
				//});
				
				//console.log(typeof json);
				//console.log(typeof json.listaimagens);
				
				
				//console.log(JSON.parse(json));
				//$("#clearBothAltura").remove();
				
				$.each(json.listaimagens, function(i, item) {
					//newhtml += item.imagem;
					newhtml += '<div class="col-md-3 cempo">';
					newhtml += '<div class="galeria-md">';								
					newhtml += '<a title="' + item.title + '" href="' + item.link + '"  data-rel="lightbox-gallery-1">';
					newhtml += '<img src="' + item.imagem + '"  class="lazy img-portifolio img-responsive" alt="' + item.caption + '">';
					newhtml += '</a>';																		
					newhtml += '</div>';
					newhtml += '</div>';					
				}) 
				
				//newhtml += '<div id="clearBothAltura" style="clear:both;"></div>';
				
				
				if(json.mais == false)
				{
					$(".show-gallery, .show-gallery-icon").empty();
				}
				
				
        

				//alert($('#geralGalerias').height());
				//alert($('#containerGalerias').height());
				
				
				var alturaActual = $("#containerGalerias").height();
				var alturaImagem = $('#containerGalerias').find('.galeria-md:first').height();
				var novaAltura = alturaImagem * json.rows + alturaActual;
				
				//alert(novaAltura);
				
				$('#containerGalerias').css("height",alturaActual);	

				
				
				//$('#containerGalerias').height($("#containerGalerias").height()).animate({height: 2000}, 1500);
				$('#containerGalerias').height($("#containerGalerias").height()).animate({height: novaAltura}, 1500);
				
				//alert($("#containerGalerias").height());
				
				//$('#containerGalerias').append(newhtml);
				
				$( newhtml ).insertBefore( "#clearBothAltura" );
				$(".loading-container").css("display","none");
				
				
				//$('.lightbox-gallery').off();
				//alert(rlArgs.script);
				//$('.btnGaleria').off('click');
				
				/*
				$('.btnGaleria').each(function(){
					$(this).off('click');
				});
				*/
				$('.btnGaleria').off('click');
				

				
				$.event.trigger( {
					type  : 'doResponsiveLightbox',
					script  : rlArgs.script,
					selector : rlArgs.selector,
					args  : rlArgs
				} );
				
				
			},
			error: function(xhr, desc, err) {
				console.log(xhr + "\n" + err);
			}
		}); // end ajax call
	});
	/***** FIM GALERIA *****/
	
	
	
});

function equalHeights(className)
{	
	var groups = {};
	var selector = "div[class*='"+ className +"']";
	var elems = jQuery( selector );
	elems.each(function(idx, elem)
	{	   
		var rx = new RegExp( className+'(\\d)+' );
		var cs = rx.exec( elem.className)[0];
		groups[cs] = groups[cs] || [];
		groups[cs].push( elem );
	});

	Object.keys(groups).forEach(function( group, idx)
	{   
		group = jQuery(groups[group]);
		if (jQuery(window).width() > 767)
		{		
			group.css("height", "auto"); //nova linha
			group.equalHeights();
		}
		else
		{
		elems.css("height", "auto");
		}
	});	
}


$(document).ready(function(){
	originalHeight = $('#gallery-container').height();
	//Botao Mostrar Mais APRESENTACAO
	$(".link_toggle").click(function(){	
		$(this).next(".div_toggle").slideToggle(function(){ 
			if($(this).is(':hidden')){
				//$(this).next(".fa").removeClass('fa-angle-up').addClass('fa-angle-down');
				$(this).parent().find(".btn-more.show-more").html('MOSTRAR MAIS');
			$(this).parent().find(".btn-more.show-more-icon").html('&nbsp;<i class="fa fa-angle-down fa-lg"></i>');
			} else{
				//$(this).next(".fa").removeClass('fa-angle-down').addClass('fa-angle-up');
				$(this).parent().find(".btn-more.show-more").html('MOSTRAR MENOS');
			$(this).parent().find(".btn-more.show-more-icon").html('&nbsp;<i class="fa fa-angle-up fa-lg"></i>');
			}
		});
	});	
	
	var i=0; 
	var limit_expand = 12;
	$('#gallery-container').find('.img-responsive').each(function() { i++; });
	
	//Botao Mostrar mais Galeria de fotos
	/*
	$(".show-gallery, .show-gallery-icon").click(function(){
		var el = $('#gallery-container');
		if(limit_expand<i){
			curHeight = el.height(),
			autoHeight = el.css('height', 'auto').height();
			el.height(curHeight).animate({height: curHeight+originalHeight}, 1000);
			limit_expand = limit_expand+12;
			console.log(i + ' - ' + limit_expand);
		}
		else{			
			$('html, body').animate({
				scrollTop: el.offset().top
			  }, 1500, function(){
				window.location.el = el;
			  });
			el.height(autoHeight).animate({height: curHeight}, 1500);
			limit_expand = 12;			
		}
	});
	*/
	
	$(".submenu-provas").find('a').each(function() {
		$(this).click(function(){
			//console.log($(this).data('ref'));
			
			$(".submenu-provas").find('a').each(function() {
				$(this).removeClass('active-item');
			});
			
			$(this).addClass('active-item');
			apply_filter();
		});
	});
	
	$("#prova-ano").change(function(){
		//console.log($(this).val());
		apply_filter();
	});
	
	$("#prova-mes").change(function(){
		//console.log($(this).val());
		apply_filter();
	});
});

//Filtro de provas
function apply_filter(){
	if($("a[class*='active-item']").data("ref")=='all'){
		$("#prova-ano").val('');
		$("#prova-ano").val('');
	}
	
	var _ano = $("#prova-ano").val();
	var _mes = $("#prova-mes").val();
	var _tipo = $("a[class*='active-item']").data("ref");

	//var _url = 'http://' + window.location.hostname + '/provas/' +'?' + (typeof _ano==='undefined' ? '' : 'syear='+_ano)+(typeof _mes==='undefined' ? '' : '&smonth='+_mes)+ (typeof _tipo==='undefined' ? '' : '&stype='+_tipo);

	if(_ano == '')
        var _url = 'http://' + window.location.hostname + '/provas/' +'?' + (typeof _ano==='undefined' ? '' : 'syear='+_ano)+ (typeof _tipo==='undefined' ? '' : '&stype='+_tipo);
    else
		var _url = 'http://' + window.location.hostname + '/provas/' +'?' + (typeof _ano==='undefined' ? '' : 'syear='+_ano)+(typeof _mes==='undefined' ? '' : '&smonth='+_mes)+ (typeof _tipo==='undefined' ? '' : '&stype='+_tipo);

    window.open(_url,"_self")
}

$(document).ready(function(){
    $("#abrir").click(function(){
        $("#janela").addClass("flutua");
        $("input[name='s']").focus();
    });
    $("#abrir2").click(function(){
        $("#janela").addClass("flutua");
        $("input[name='s']").focus();
    });
    $("#fechar").click(function(){
        $("#janela").removeClass("flutua");
    });
});